// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"60fd235e","787":"b397f992"}[chunkId] + ".chunk.js";
};